import { Info } from "lucide-react";
import ViewMgtDevicePanel from "../ViewMgtDevicePanel";
import { ViewMgtDeviceStatusValue } from "./ViewMgtDeviceStatusValue";

export default function ViewMgtDeviceStatusInfo({ device }: { deviceId?: string | null | undefined, device?: any | undefined | null }) {

  return (
    <ViewMgtDevicePanel title="Info" icon={<Info size={16} />}>
      <div className="grid grid-cols-1 gap-0">
        
        <ViewMgtDeviceStatusValue 
          label="Firmware"
          color="text-slate-500"
          timestamp={device?.StatusUpdateLog?.logTimestamp}
          value={device?.StatusUpdateLog?.currentFirmwareVersion ? `${device?.StatusUpdateLog?.currentFirmwareVersion?.majorVersion}.${device?.StatusUpdateLog?.currentFirmwareVersion?.minorVersion}.${device?.StatusUpdateLog?.currentFirmwareVersion?.patchVersion}` : ""}
          />

        <ViewMgtDeviceStatusValue 
          label="SIM CCID"
          color="text-slate-500"
          value={device?.StatusUpdateLog?.simCcid}
          timestamp={device?.StatusUpdateLog?.logTimestamp}
          />

        <ViewMgtDeviceStatusValue 
          label="Auto-Lock"
          timestamp={device?.StatusUpdateLog?.logTimestamp}
          color={device?.StatusUpdateLog?.autoLockPeriodSec > 0 ? " text-green-500" : "text-red-500"}
          value={device?.StatusUpdateLog?.autoLockPeriodSec > 0 ? `On (${device?.StatusUpdateLog?.autoLockPeriodSec} seconds)` : 'Off'}
          />
        
      </div>
    </ViewMgtDevicePanel>
  );
}
